import { Skeleton } from "@/components/kit";
import type { CustomerCohortsResultDTO } from "@/modules/reports/domain/types";

type CustomerCohortTableProps = {
  result?: CustomerCohortsResultDTO;
  isLoading?: boolean;
};

export function CustomerCohortTable({
  result,
  isLoading,
}: CustomerCohortTableProps) {
  if (isLoading) {
    return <Skeleton className="hidden h-48 w-full rounded-2xl sm:block" />;
  }

  const rows = result?.data ?? [];
  const maxOffset = result?.maxOffset ?? 6;

  if (rows.length === 0) {
    return null;
  }

  const offsets = Array.from({ length: maxOffset + 1 }, (_, index) => index);

  return (
    <div className="brand-card hidden overflow-x-auto p-4 sm:block sm:p-5">
      <h3 className="mb-3 font-medium text-sm">ຕາຕະລາງ cohort</h3>
      <table className="w-full min-w-[520px] text-sm">
        <thead>
          <tr className="border-border border-b text-left text-muted-foreground text-xs">
            <th className="pb-2 font-medium">ເດືອນ cohort</th>
            <th className="pb-2 text-right font-medium">ຂະໜາດ</th>
            {offsets.map((offset) => (
              <th key={offset} className="pb-2 text-right font-medium">
                +{offset}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.cohortMonth}
              className="border-border/60 border-b last:border-0"
            >
              <td className="py-2 font-medium tabular-nums">{row.cohortMonth}</td>
              <td className="py-2 text-right tabular-nums">{row.cohortSize}</td>
              {offsets.map((offset) => {
                const percent = row.retentionByMonth[offset] ?? 0;
                const retained = row.retainedCounts[offset] ?? 0;
                return (
                  <td
                    key={offset}
                    className="py-2 text-right tabular-nums text-xs"
                    title={`${retained}/${row.cohortSize}`}
                  >
                    {percent}%
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
